// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__hC67F","FooterH3MRA":"Footer_FooterH3MRA__nSQOG","FooterLiMRA":"Footer_FooterLiMRA__xfWak","footerList":"Footer_footerList__FFtX9"};